import { render, staticRenderFns } from "./position.vue?vue&type=template&id=4a858252&scoped=true"
import script from "./position.vue?vue&type=script&lang=js"
export * from "./position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a858252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a858252')) {
      api.createRecord('4a858252', component.options)
    } else {
      api.reload('4a858252', component.options)
    }
    module.hot.accept("./position.vue?vue&type=template&id=4a858252&scoped=true", function () {
      api.rerender('4a858252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/position.vue"
export default component.exports